import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "react-bootstrap-icons";

export default function WhyUs() {
  const reasons = [
    "We combine cultural influence with financial intelligence.",
    "Real creators. Real results.",
    "Data-backed campaigns.",
    "Founders in the driver’s seat.",
    "Built for brands that want more than hype.",
    "No fluff. Just growth.",
  ];

  const fade = {
    hidden: { opacity: 0, y: 20 },
    show: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.12, duration: 0.6 },
    }),
  };

  return (
    <section
      id="whyus"
      className="py-5"
      style={{ background: "linear-gradient(to bottom, #ffffff, #f9f9f9)" }}
    >
      <div className="container">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-5"
        >
          <h2 className="fw-bold mb-3" style={{ fontSize: "2.3rem" }}>
            Why <span className="text-danger">Digital Ledger Media</span>
          </h2>
        </motion.div>

        {/* Reason Cards */}
        <div className="row justify-content-center g-3">
          {reasons.map((r, i) => (
            <motion.div
              key={i}
              className="col-12 col-sm-6 col-lg-4"
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={fade}
            >
              <motion.div
                whileHover={{
                  scale: 1.03,
                  backgroundColor: "rgba(255,0,0,0.04)",
                }}
                className="d-flex align-items-start gap-3 p-3 rounded-4 h-100"
                style={{
                  background: "rgba(255,255,255,0.8)",
                  backdropFilter: "blur(6px)",
                  border: "1px solid rgba(0,0,0,0.05)",
                  transition: "0.3s ease",
                }}
              >
                <CheckCircle size={26} className="text-danger mt-1" />
                <p className="fw-semibold text-secondary mb-0 small">{r}</p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
